import facebook from "./icons/flogo-HexRBG-Wht-72.svg";
import google from "./icons/icons8-google-48.png";
import github from "./icons/github.svg";
import timer from "./icons/timer-2-line.png";
import disagree from "./icons/dislike-line.png";


const icons = {
  google: google,
  facebook: facebook,
  github: github,
  timer: timer,
  disgaree: disagree
};

export default icons;
